export default __webpack_public_path__ + "static/media/InterAppIcon.1ed7574c.svg";